import InsideSalesEditAttachments from './InsideSalesEditAttachments';

export default InsideSalesEditAttachments;
